import _ from 'lodash'
import React, {useState} from 'react'
import { Search, Icon } from 'semantic-ui-react'

const initialState = {
  loading: false,
  results: [],
  value: ''
}

function searchReducer(state, action) {
  switch (action.type) {
    case 'CLEAN_QUERY':
      return initialState
    case 'START_SEARCH':
      return { ...state, loading: action.query.length > 1, value: action.query }
    case 'FINISH_SEARCH':
      return { ...state, loading: false, results: action.results }
    case 'UPDATE_SELECTION':
      return { ...state, value: action.selection }

    default:
      throw new Error()
  }
}

function sort_results(json, search_value) {
  let sorted = []

  json.map((geo) => {
    return sorted.push(geo.location.toLowerCase().indexOf(search_value.toLocaleLowerCase()) !== -1 ? geo.location : geo.country)
  })

  let exact_word = null

  sorted.map((location) => {
    if (location.toLowerCase() === search_value.toLowerCase()) {
      exact_word = location
    }
    return location
  })

  if (exact_word !== null) {
    return [exact_word]
  }
  else {
    sorted.sort((a, b) => a.length - b.length);

    return [...new Set(sorted)]
  }

}

function check_results(dispatch, json, search_value) {
  if (json.length === 0) {
    json = [
        {title: search_value}, {title: "United States"}, {title: "Canada"},
        {title: "Germany"}, {title: "United Kingdom"}, {title: "France"}
    ]
  }
  else {
    let sorted = sort_results(json, search_value)
    json = sorted.map((location) => {
      return {title: location}
    })
  }
  dispatch({type: 'FINISH_SEARCH', results: json});
}

let debounced = _.debounce(function (callback) {return callback();}, 500);

const SearchBarLocation = (props) => {
  const [state, dispatch] = React.useReducer(searchReducer, initialState)
  const { loading, results, value } = state
  const [open, setOpen] = useState(false)

    const handleKeyDown = (event) => {
    if (event.charCode === 13 && (value.length === 0 || value.length > 1)) {
      props.setQuery(previousState => {
        return { ...previousState, search_location_query: value, page: 0 }
      });
      setOpen(false)
    }
  }

  const timeoutRef = React.useRef()
  const handleSearchChange = React.useCallback((e, data) => {
    clearTimeout(timeoutRef.current)
    setOpen(true)
    dispatch({type: 'START_SEARCH', query: data.value})

    timeoutRef.current = setTimeout(() => {
      if (data.value.length === 0) {
        dispatch({type: 'CLEAN_QUERY'})
        return
      }

      if (data.value.length > 1) {
        debounced(function () {
          fetch(`${process.env.REACT_APP_BASE_URL}/locations/?search_location_query=${data.value}`)
              .then((res) => res.json())
              .then((json) => check_results(dispatch, json, data.value))
        });
      }
    }, 300)

  }, [])

  React.useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [])

  return (
        <Search
            input={{fluid: props.is_mobile}}
            aligned="right"
            size={props.is_mobile ? 'tiny': 'small'}
            minCharacters={2}
            loading={loading}
            icon={<Icon color="green" name="map marker alternate"/>}
            placeholder='Search Locations...'
            onResultSelect={(e, data) => {
              props.setQuery(previousState => {
                return { ...previousState, search_location_query: data.result.title, page: 0 }
              });
              setOpen(false)
            }}
            onBlur={(e, v) => {setOpen(false)}}
            onSearchChange={handleSearchChange}
            results={results}
            value={value}
            onKeyPress={handleKeyDown}
            noResultsMessage="No locations found."
            showNoResults={false}
            open={open}
        />
  )
}

export default SearchBarLocation;